var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0a1014adf6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45.15625 28.972656 L 330 28.972656 L 330 292 L 45.15625 292 Z M 45.15625 28.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd1885dc79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92 123 L 235 123 L 235 346.222656 L 92 346.222656 Z M 92 123 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a1014adf6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M 232.164062 264.363281 C 287.507812 254.402344 329.839844 205.707031 329.839844 147.605469 C 329.839844 82.367188 276.464844 28.988281 211.222656 28.988281 L 45.15625 28.988281 L 92.605469 76.4375 L 211.222656 76.4375 C 250.367188 76.4375 282.390625 108.464844 282.390625 147.609375 C 282.390625 186.753906 250.367188 218.78125 211.222656 218.78125 L 187.5 218.78125 L 187.5 291.21875 L 234.949219 263.824219 C 234.027344 264.015625 233.097656 264.195312 232.164062 264.363281 Z M 232.164062 264.363281 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd1885dc79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M 140.054688 266.222656 C 140.054688 234.597656 140.054688 202.964844 140.054688 171.332031 L 211.21875 171.332031 C 224.273438 171.332031 234.945312 160.660156 234.945312 147.609375 C 234.945312 134.558594 224.273438 123.886719 211.21875 123.886719 L 92.605469 123.886719 C 92.605469 171.332031 92.605469 218.78125 92.605469 266.222656 L 92.605469 346.007812 L 140.050781 318.613281 L 140.050781 266.222656 Z M 140.054688 266.222656 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg2);
export default __webpack_public_path__ + "static/media/LogoSvg2.4f6a8e3617a4a0de5a8450d1f208996b.svg";
export { ForwardRef as ReactComponent };